import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import "./App.css";
import AppRoutes from "./layout/AppLayout";
import { InfoModal } from "./shared/modals/InfoModal";
import { PortalModal } from "./shared/modals/PortalModal";
import { BlockedModal } from "./shared/modals/BlockedModal";
import { ScrollContext } from "./containers/scrollContextProvider/scrollContextProvider";
import { GlobaContextProvider } from "./context/globalContext";
import useMedia from "./hooks/useMedia";
import OverlayScrollbarsComponent from "./shared/OverlayScroll/OverlayScrollbarsComponent";
import Sprite from "./sprite";
import { GlobalStylesWrapper } from "./GlobalStyles";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import PiOnboardingRoutes from "./routes/piOnboarding";
import LoanApplicationRoutes from "./routes/LoanApplication";
import { ONBOARDING_BASE_PATHS } from "./components/piOnboarding/steps/constants";

function getAppRoutes(pathname) {
  const firstPathSegment = pathname.split("/")[1]?.toLowerCase();

  if (firstPathSegment === ONBOARDING_BASE_PATHS.loan) {
    return <LoanApplicationRoutes />;
  }

  if (firstPathSegment === ONBOARDING_BASE_PATHS.pi) {
    return <PiOnboardingRoutes />;
  }

  return <AppRoutes />;
}

function App() {
  const { scrollbarRef } = useContext(ScrollContext);
  const [mobileNav, setShowMobNav] = useState(false);
  const isTablet = useMedia("(min-width: 768px)");
  const history = useHistory();
  const pathname = history.location.pathname;

  const queryClient = new QueryClient();

  const [locationKeys, setLocationKeys] = useState([]);
  function clearConsole() {
    const production = process.env.NODE_ENV === "production";
    if (production) console.log = console.warn = console.error = () => { };
  }
  clearConsole();

  useEffect(() => {
    return history.listen((location) => {
      if (history.action === "PUSH") {
        setLocationKeys([location.key]);
      }

      if (history.action === "POP") {
        if (locationKeys[1] === location.key) {
          setLocationKeys(([_, ...keys]) => keys);

          // Handle forward event
        } else {
          setLocationKeys((keys) => [location.key, ...keys]);

          // Handle back event
        }
      }
    });
  }, [locationKeys, history]);

  useEffect(() => {
    if (window.innerWidth < 768 || isTablet) {
      setShowMobNav(false);
    }
  }, [pathname, isTablet]);

  return (
    <React.Suspense fallback={<div>...</div>}>
      <QueryClientProvider client={queryClient}>
        <div className="App">
          <GlobalStylesWrapper>
            <GlobaContextProvider>
              <div
                className={`dashboard${mobileNav === false ? " opened" : ""}`}
              >
                {mobileNav && (
                  <div
                    className="shadow-layout"
                    onClick={() => setShowMobNav(false)}
                  />
                )}
                <OverlayScrollbarsComponent
                  className={"layout-scroll"}
                  scrollbarRef={scrollbarRef}
                >
                  <div>{getAppRoutes(pathname)}</div>
                </OverlayScrollbarsComponent>
              </div>

              <BlockedModal />
              <PortalModal />
              <InfoModal />
            </GlobaContextProvider>
            <div style={{ display: "none" }}>
              <Sprite />
            </div>
          </GlobalStylesWrapper>
        </div>
      </QueryClientProvider>
    </React.Suspense>
  );
}

export default App;
